export default __webpack_public_path__ + "static/media/17.f19db133.png";